export const IMAGE_CROP_FILE_TYPES = ['image/bmp', 'image/png', 'image/jpeg', 'image/webp'];
